import koMessages from "@/translations/ko.json";

export const STATIC_LOCALE = "ko";
export const STATIC_MESSAGES = koMessages;

function getByPath(source, path) {
  if (!path) return source;

  return String(path)
    .split(".")
    .reduce((current, key) => {
      if (current && Object.prototype.hasOwnProperty.call(current, key)) {
        return current[key];
      }
      return undefined;
    }, source);
}

function interpolate(template, values) {
  if (!values || typeof template !== "string") return template;

  return template.replace(/\{([^{}]+)\}/g, (match, key) => {
    const value = values[key.trim()];
    if (value === undefined || value === null) return match;
    return String(value);
  });
}

export function translateMessage(namespace, key, values) {
  const fullKey = namespace ? `${namespace}.${key}` : key;
  const value = getByPath(STATIC_MESSAGES, fullKey);

  if (typeof value === "string") {
    return interpolate(value, values);
  }

  return String(key ?? "");
}

export function useTranslations(namespace) {
  const translate = (key, values) => translateMessage(namespace, key, values);
  translate.has = (key) => getByPath(STATIC_MESSAGES, namespace ? `${namespace}.${key}` : key) !== undefined;
  translate.raw = (key) => getByPath(STATIC_MESSAGES, namespace ? `${namespace}.${key}` : key);
  return translate;
}

export function useLocale() {
  return STATIC_LOCALE;
}
